/**
 * Initializes a set of section elements as instances of a given constructor function.
 *
 * @param {string} element - The CSS selector for the section elements to initialize.
 * @param {function} constructorFn - The constructor function to use for initialization.
 */

export const initSection = (element, constructorFn) => {
  if (!element || !constructorFn) {
    console.warn("Missing arguments for initSection.");
    return;
  }

  const sectionElements = document.querySelectorAll(element);

  if (!sectionElements) {
    console.warn(`No section elements found for ${element}`);
    return;
  }

  for (const sectionElement of sectionElements) {
    const sectionInstance = new constructorFn(sectionElement);
  }
};
